import Image from 'next/legacy/image'
import { useAuthenticationStatus } from '@nhost/nextjs'

import CountDown from 'components/countdown'
import { Button, Container, Text } from 'components/atomic'
import { ClaimDateTime, isClaimDatePassed } from 'lib/constants'

export default function Claws() {
  const { isAuthenticated } = useAuthenticationStatus()

  return (
    <div className="relative">
      <Container className="pb-16 lg:px-28 lg:pb-64 xl:px-40">
        <div className="pt-24 lg:max-w-2xl lg:pt-56">
          <Text variant="h1" tag="h1" className="mt-32 lg:mt-0">
            CLAWS COME OUT TO PLAY
          </Text>
          <div className="absolute inset-0 -z-10 mt-0 aspect-auto opacity-80">
            <Image src="/images/mission/claws.jpg" layout="fill" objectFit="cover" alt="Claws" priority />
          </div>
          {isClaimDatePassed ? (
            <div className="lg:max-w-lg">
              <Text variant="p2" tag="p" className="mb-4 mt-8 tracking-wide text-white/80">
                Claws are the lifeblood of the Midnight Society. They are the players who thirst for blood and glory,
                seeking only the rewards earned through their skills as a fighter.
              </Text>
              <Text variant="p2" tag="p" className="mb-4 font-semibold tracking-wide text-secondary">
                ALL SERIES 0 PATCH CLAIMED
                <br />
                FOUNDERS ACCESS PASS period closed
              </Text>
              <Text variant="p2" tag="p" className="font-semibold tracking-wide text-white">
                Create an account for future Series releases.
              </Text>
              <div className="mb-20 mt-12 lg:mb-8">
                <Button href="/profile">{isAuthenticated ? 'My Profile' : 'Create Account'}</Button>
              </div>
            </div>
          ) : (
            <div className="lg:max-w-lg">
              <Text variant="p2" tag="p" className="mb-4 mt-8 tracking-wide text-white/80">
                Claws are the lifeblood of the Midnight Society. They are the players who thirst for blood and glory,
                seeking only the rewards earned through their skills as a fighter.
              </Text>
              <Text variant="p2" tag="p" className="tracking-wide text-white/80">
                <span className="font-semibold text-secondary">Claim the limited time ‘DAY ZERO’ Claw Collectible</span>{' '}
                available to everyone who applies, completely for free.
              </Text>
              <div className="mb-20 mt-12 lg:mb-8">
                <Button href="/claws-nft">Claim Now</Button>
              </div>
              <CountDown size="small" targetDateTime={ClaimDateTime} />
            </div>
          )}
        </div>
      </Container>
    </div>
  )
}
